import { useParams } from "react-router-dom";
import useLabels from "../../../hooks/useLabels";
import Timeline from "../Timeline";

import "./styles/index.scss";

const Tracking = ({ type = 'tank', dates = {}, tank = {}, lot = {}, tanks = [], lots = [], isLoading = false, setIsLoading = () => null }) => {
  const { id } = useParams();
  const [getLabel] = useLabels();

  const renderTracking = () => {
    return <Timeline type={type} tanks={tanks} lots={lots} isLoading= {isLoading} setIsLoading={setIsLoading} dates={dates} lotName={type === 'lot' ? lot?.name : ''} labelName={type === 'tank' ? getLabel("tankTrackingTitlePage", { name: tank?.name || id }) : 
    getLabel("lotTrackingTitlePage", { name: lot?.name || id })} name={type === 'tank' ? tank?.name || id : lot?.name || id } />
  };

  return (
    <div className="">
      {renderTracking()}
    </div>
  );
};

export default Tracking;
